import { MessagingTopology, OutputTargetNode } from '@internal/open-catalog';
import { Box, Grid, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../../../components/accordion/accordion.styled';
import { OutputTargetDialog } from './dialog.output.target';
import { usePanelEditableStyles } from './panel.style';

export function OutputTargetPanel(props: {
  expanded: string | boolean,
  topology: MessagingTopology
  onAccordionStateChange: (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => void,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { topology, expanded, onAccordionStateChange, onTopologyChange } = props;

  const classes = usePanelEditableStyles();

  const [targets, setTargets] = useState<OutputTargetNode[]>([]);

  const [formDialog, setFormDialog] = useState(false);

  const openTargetFormDialog = (event: React.MouseEvent): void => {
    event.stopPropagation();
    setFormDialog(true);
  }

  const isDuplicatedTarget = (newTarget: OutputTargetNode): boolean => {
    const found = topology.output?.targets.filter(target => target.name === newTarget.name);
    return (found || []).length > 0;
  }

  const closeTargetFormDialog = (newTarget?: OutputTargetNode): void => {

    if (newTarget && !isDuplicatedTarget(newTarget)) {
      topology.output?.targets.unshift(newTarget)
      onTopologyChange(newTarget.name);
    }
    setFormDialog(false);
  }

  const removeTarget = (index: number): void => {
    topology.output?.targets.splice(index, 1);
    onTopologyChange();
  };

  useEffect(() => {
    setTargets(topology.output?.targets || []);
  }, [topology]);

  return (<>
    
    {topology.output && (
      <OutputTargetDialog open={formDialog} source={topology.output} environment={topology.vhost} onClose={closeTargetFormDialog} />
    )}

    <Accordion expanded={expanded === 'targets'} onChange={onAccordionStateChange('targets')}>
    
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <ListItem className={classes.headerWithActions}>
          <ListItemText primary="Targets" />
          <IconButton edge="start" color='secondary' size="small" title="Produces to external system service." onClick={openTargetFormDialog}>
            <AddIcon />
          </IconButton>
        </ListItem>
      </AccordionSummary>
    
      <AccordionDetails>

        {!targets.length && (
          <Typography variant='caption' component="p">No systems services as output targets defined, let's add some ! :D</Typography>
        )}

        {targets.length > 0 && (
          <Grid container spacing={1} className={classes.root}>
            {targets.map((t, index) => (
              <Grid key={index} item xs={12}>
                <Box className={classes.group}>
                  <List dense className={classes.list}>
                    <ListItem>
                      <ListItemText primary={t.name} secondary={t.type} title={t.name} />
                      <IconButton edge="start" size="small" title="Remove target" onClick={() => removeTarget(index)}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  </>);
};
